import { Container } from '../../odie';

import { app } from '../app';
import { IAnimation } from '../../lib/pattern/IAnimation';
import { MovieClip } from '@play-co/timestep-core/ui';
import { AssetDescription } from '@play-co/timestep-core';

/*
    radial glare animation
*/
export class StarGlareAnimation extends Container implements IAnimation {
  // init
  //-------------------------------------------------------------------------
  public static assets(): (string | AssetDescription<any>)[] {
    return [
      {
        url: 'assets/ui/match2/movieclips/in_game_stars',
        loadMethod: MovieClip.animationLoader,
      },
    ];
  }

  // impl
  //-------------------------------------------------------------------------
  public async start(): Promise<void> {
    // create fx
    const fx = this._createFx();

    // animate shine and glare
    await this._animateFx(fx);
  }

  public stop() {}

  // private: animators
  //-------------------------------------------------------------------------
  private async _animateFx(fx: MovieClip) {
    // spawn fx
    this.view.addSubview(fx);

    // play fx animation
    await fx.playAsync('starburst_anim');
    app.sound.play('sfx-star2');

    // despawn fx
    this.view.removeSubview(fx);
  }

  // private: factory
  //-------------------------------------------------------------------------
  private _createFx(): MovieClip {
    return new MovieClip({
      url: 'assets/ui/match2/movieclips/in_game_stars',
      fps: 50,
    });
  }
}
